//addvertise.js
import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import "../style.scss";

//design alter,hide and show
const PhotoIcon = () => (
  <svg width="18" height="18" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="20" height="18" rx="4" stroke="#E64C9D" strokeWidth="1.8" />
    <circle cx="9" cy="10" r="2" stroke="#E64C9D" strokeWidth="1.8" />
    <path d="M4 18L10 12L14 16L18 12L22 17" stroke="#E64C9D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8H14M14 8L9 3M14 8L9 13" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LogoMark = () => (
  <svg width="30" height="30" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M35.3248 29.1724L25.2174 7.49617C24.6429 6.26425 23.6026 5.31101 22.3253 4.84614C21.0479 4.38128 19.6382 4.44287 18.4063 5.01738C17.1744 5.59188 16.2212 6.63223 15.7563 7.90956C15.2914 9.1869 15.353 10.5966 15.9275 11.8285L26.0357 33.5038C26.6101 34.7358 27.6504 35.689 28.9276 36.154C30.2049 36.6189 31.6145 36.5574 32.8464 35.9831C34.0784 35.4087 35.0316 34.3684 35.4966 33.0912C35.9615 31.8139 35.8992 30.4043 35.3248 29.1724Z" stroke="white" strokeWidth="2" />
    <path d="M20.0202 22.6662L14.9652 33.5038C14.6808 34.1138 14.279 34.6618 13.7827 35.1165C13.2865 35.5713 12.7056 35.9238 12.0731 36.1539C11.4406 36.3841 10.769 36.4875 10.0966 36.4581C9.42414 36.4287 8.7641 36.2671 8.15412 35.9826C6.92237 35.4082 5.96926 34.368 5.5044 33.0908C5.03955 31.8137 5.10103 30.4042 5.67533 29.1724L15.6947 7.6875" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <path d="M8.15479 35.9825C10.7201 37.1787 13.7693 36.0688 14.9655 33.5036C16.1617 30.9383 15.0519 27.889 12.4866 26.6928C9.92136 25.4966 6.87208 26.6065 5.67588 29.1717C4.47967 31.737 5.58952 34.7863 8.15479 35.9825Z" stroke="white" strokeWidth="2" />
  </svg>
);

const GlobeIcon = () => (
  <svg width="17" height="17" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.16623 13C2.16623 11.5773 2.44646 10.1685 2.99091 8.85404C3.53537 7.53962 4.33338 6.3453 5.3394 5.33928C6.34542 4.33326 7.53974 3.53524 8.85416 2.99079C10.1686 2.44634 11.5774 2.16611 13.0001 2.16611C14.4228 2.16611 15.8316 2.44634 17.1461 2.99079C18.4605 3.53524 19.6548 4.33326 20.6608 5.33928C21.6668 6.3453 22.4649 7.53962 23.0093 8.85404C23.5538 10.1685 23.834 11.5773 23.834 13C23.834 15.8733 22.6926 18.6289 20.6608 20.6607C18.6291 22.6924 15.8734 23.8339 13.0001 23.8339C10.1268 23.8339 7.37115 22.6924 5.3394 20.6607C3.30766 18.6289 2.16623 15.8733 2.16623 13Z" stroke="#055075" strokeWidth="1.5" />
    <path d="M8.66531 13C8.66531 11.5776 8.77797 10.1681 8.99572 8.85406C9.21239 7.53998 9.53197 6.34615 9.93497 5.33973C10.3369 4.33331 10.8146 3.53598 11.3401 2.99106C11.8666 2.44723 12.4299 2.16665 12.9986 2.16665C13.5674 2.16665 14.1307 2.44723 14.6561 2.99106C15.1826 3.53598 15.6604 4.3344 16.0623 5.33973C16.4653 6.34615 16.7849 7.5389 17.0026 8.85406C17.2248 10.2248 17.335 11.6114 17.332 13C17.332 14.4224 17.2204 15.8318 17.0026 17.1459C16.7849 18.46 16.4653 19.6538 16.0623 20.6602C15.6604 21.6666 15.1826 22.464 14.6572 23.0089C14.1307 23.5516 13.5674 23.8333 12.9986 23.8333C12.4299 23.8333 11.8666 23.5527 11.3411 23.0089C10.8146 22.464 10.3369 21.6656 9.93497 20.6602C9.53197 19.6538 9.21239 18.4611 8.99572 17.1459C8.77689 15.8318 8.66531 14.4224 8.66531 13Z" stroke="#055075" strokeWidth="1.5" />
    <path d="M23.832 13H2.16536" stroke="#055075" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const TrashIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="25.3867" y="26" width="25.3864" height="26" rx="12.6932" transform="rotate(-180 25.3867 26)" fill="white" />
    <path d="M9.86857 19C9.55096 19 9.27929 18.8795 9.05358 18.6386C8.82786 18.3976 8.71477 18.1087 8.71429 17.7718V8.34686H8.35715C8.25572 8.34686 8.17096 8.31034 8.10286 8.23729C8.03477 8.16424 8.00048 8.07368 8 7.96563C7.99953 7.85758 8.03381 7.76728 8.10286 7.69474C8.17191 7.62219 8.25667 7.58592 8.35715 7.58592H10.8571C10.8571 7.42866 10.9119 7.29169 11.0214 7.17502C11.131 7.05834 11.2595 7 11.4071 7H14.5929C14.7405 7 14.869 7.05834 14.9786 7.17502C15.0881 7.29169 15.1429 7.42866 15.1429 7.58592L17.6429 7.58592C17.7443 7.58592 17.829 7.62245 17.8971 7.6955C17.9652 7.76855 17.9995 7.8591 18 7.96715C18.0005 8.07521 17.9662 8.1655 17.8971 8.23805C17.8281 8.31059 17.7433 8.34686 17.6429 8.34686H17.2857V17.7711C17.2857 18.1089 17.1726 18.3981 16.9464 18.6386C16.7202 18.879 16.4488 18.9995 16.1321 19H9.86857ZM16.5714 8.34686H9.42857V17.7711C9.42857 17.9075 9.46977 18.0197 9.55215 18.1074C9.63453 18.1952 9.74 18.2391 9.86857 18.2391H16.1321C16.2602 18.2391 16.3655 18.1952 16.4479 18.1074C16.5302 18.0197 16.5714 17.9075 16.5714 17.7711V8.34686ZM12.0464 16.6076C12.1145 16.5346 12.1486 16.4443 12.1486 16.3367V10.2492C12.1486 10.1412 12.1143 10.0509 12.0457 9.97831C11.9771 9.90577 11.8921 9.86925 11.7907 9.86874C11.6893 9.86823 11.6045 9.90476 11.5364 9.97831C11.4683 10.0519 11.4343 10.1422 11.4343 10.2492V16.3367C11.4343 16.4448 11.4686 16.5351 11.5371 16.6076C11.6057 16.6807 11.6905 16.7172 11.7914 16.7172C11.8929 16.7172 11.9779 16.6807 12.0464 16.6076ZM14.4636 16.6076C14.5317 16.5346 14.5657 16.4443 14.5657 16.3367V10.2492C14.5657 10.1412 14.5314 10.0509 14.4629 9.97831C14.3943 9.90526 14.3095 9.86874 14.2086 9.86874C14.1071 9.86874 14.0221 9.90526 13.9536 9.97831C13.885 10.0514 13.851 10.1417 13.8514 10.2492V16.3367C13.8514 16.4448 13.8857 16.5351 13.9543 16.6076C14.0229 16.6802 14.1079 16.7167 14.2093 16.7172C14.3107 16.7177 14.3955 16.6812 14.4636 16.6076Z" fill="#6B6B6B" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 17L15 12L10 7" stroke="#0B3A52" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 7L9 12L14 17" stroke="#0B3A52" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BackChevronIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 6L9 12L15 18" stroke="#FFFFFF" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4V20M4 12H20" stroke="#E33A34" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

const DownChevronIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9L12 15L18 9" stroke="#0B3A52" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const UploadImageIcon = () => (
  <svg width="34" height="34" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="20" height="18" rx="4" stroke="#FFFFFF" strokeWidth="1.8" />
    <circle cx="9" cy="10" r="2" stroke="#FFFFFF" strokeWidth="1.8" />
    <path d="M4 18L10 12L14 16L18 12L22 17" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PhotoTabIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8C18 8.53043 17.7893 9.03914 17.4142 9.41421C17.0391 9.78929 16.5304 10 16 10C15.4696 10 14.9609 9.78929 14.5858 9.41421C14.2107 9.03914 14 8.53043 14 8C14 7.46957 14.2107 6.96086 14.5858 6.58579C14.9609 6.21071 15.4696 6 16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8Z" fill="#055075" />
    <path fillRule="evenodd" clipRule="evenodd" d="M11.943 1.25002H12.057C14.366 1.25002 16.175 1.25002 17.587 1.44002C19.031 1.63402 20.171 2.04002 21.066 2.93402C21.961 3.82902 22.366 4.96902 22.56 6.41402C22.75 7.82502 22.75 9.63402 22.75 11.943V12.031C22.75 13.94 22.75 15.502 22.646 16.774C22.542 18.054 22.329 19.121 21.851 20.009C21.6417 20.3997 21.38 20.752 21.066 21.066C20.171 21.961 19.031 22.366 17.586 22.56C16.175 22.75 14.366 22.75 12.057 22.75H11.943C9.634 22.75 7.825 22.75 6.413 22.56C4.969 22.366 3.829 21.96 2.934 21.066C2.141 20.273 1.731 19.286 1.514 18.06C1.299 16.857 1.26 15.36 1.252 13.502C1.25067 13.0287 1.25 12.528 1.25 12V11.942C1.25 9.63302 1.25 7.82402 1.44 6.41202C1.634 4.96802 2.04 3.82802 2.934 2.93302C3.829 2.03802 4.969 1.63302 6.414 1.43902C7.825 1.24902 9.634 1.24902 11.943 1.24902M6.613 2.92502C5.335 3.09702 4.564 3.42502 3.995 3.99402C3.425 4.56402 3.098 5.33402 2.926 6.61302C2.752 7.91302 2.75 9.62102 2.75 11.999C2.75 12.5277 2.75067 13.026 2.752 13.494C2.76 15.368 2.802 16.74 2.99 17.797C3.174 18.832 3.488 19.497 3.995 20.004C4.565 20.574 5.335 20.901 6.614 21.073C7.914 21.247 9.622 21.249 12 21.249C14.378 21.249 16.086 21.247 17.386 21.073C18.665 20.901 19.436 20.573 20.006 20.004C20.216 19.794 20.387 19.562 20.53 19.297C20.862 18.681 21.053 17.857 21.151 16.652C21.249 15.447 21.25 13.945 21.25 11.999C21.25 9.62102 21.248 7.91302 21.074 6.61302C20.902 5.33402 20.574 4.56302 20.005 3.99302C19.435 3.42402 18.665 3.09702 17.386 2.92502C16.086 2.75102 14.378 2.74902 12 2.74902C9.622 2.74902 7.913 2.75102 6.613 2.92502Z" fill="#055075" />
    <path opacity="0.4" d="M20.607 19.1461L17.777 16.5991C17.2723 16.1447 16.6283 15.875 15.9503 15.8341C15.2724 15.7933 14.6007 15.9836 14.045 16.3741L13.746 16.5841C13.3608 16.8548 12.8925 16.9809 12.4235 16.9403C11.9546 16.8997 11.5149 16.6949 11.182 16.3621L6.892 12.0721C6.47936 11.6598 5.9255 11.4197 5.34252 11.4004C4.75955 11.3811 4.19101 11.584 3.752 11.9681L2.75 12.8441L2.752 13.4941C2.76 15.3691 2.802 16.7411 2.99 17.7981C3.175 18.8331 3.488 19.4981 3.995 20.0051C4.565 20.5751 5.335 20.9021 6.614 21.0741C7.914 21.2481 9.622 21.2501 12 21.2501C14.378 21.2501 16.087 21.2481 17.387 21.0741C18.665 20.9021 19.436 20.5741 20.005 20.0051C20.2546 19.7563 20.4583 19.4656 20.607 19.1461Z" fill="#055075" />
  </svg>
);

const VideoTabIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.737 8.19587L16.211 11.5688C16.3769 11.6554 16.5164 11.7884 16.6138 11.9528C16.7113 12.1173 16.7629 12.3068 16.7629 12.5C16.7629 12.6933 16.7113 12.8828 16.6138 13.0472C16.5164 13.2117 16.3769 13.3447 16.211 13.4313L9.737 16.8042C9.55398 16.8996 9.35058 16.9447 9.14614 16.9351C8.94169 16.9255 8.74299 16.8616 8.56892 16.7495C8.39485 16.6374 8.2512 16.4808 8.15163 16.2946C8.05205 16.1083 7.99985 15.8986 8 15.6854V9.31462C7.99985 9.10144 8.05205 8.89176 8.15163 8.70551C8.2512 8.51927 8.39485 8.36265 8.56892 8.25054C8.74299 8.13843 8.94169 8.07455 9.14614 8.06498C9.35058 8.05541 9.55398 8.10047 9.737 8.19587Z" stroke="#055075" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 21.875C16.9706 21.875 21 17.6777 21 12.5C21 7.32233 16.9706 3.125 12 3.125C7.02944 3.125 3 7.32233 3 12.5C3 17.6777 7.02944 21.875 12 21.875Z" stroke="#055075" />
  </svg>
);

const TextTabIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 3.5C4.60218 3.5 4.22064 3.65804 3.93934 3.93934C3.65804 4.22064 3.5 4.60218 3.5 5C3.5 5.39782 3.65804 5.77936 3.93934 6.06066C4.22064 6.34196 4.60218 6.5 5 6.5H10.5V20C10.5 20.3978 10.658 20.7794 10.9393 21.0607C11.2206 21.342 11.6022 21.5 12 21.5C12.3978 21.5 12.7794 21.342 13.0607 21.0607C13.342 20.7794 13.5 20.3978 13.5 20V6.5H19C19.3978 6.5 19.7794 6.34196 20.0607 6.06066C20.342 5.77936 20.5 5.39782 20.5 5C20.5 4.60218 20.342 4.22064 20.0607 3.93934C19.7794 3.65804 19.3978 3.5 19 3.5H5Z" fill="#055075" />
  </svg>
);

const CardBackground = () => (
  <div className="photo-advertisement-card__bg">
    <svg viewBox="0 0 337 43" preserveAspectRatio="none">
      <path
        d="M0 0H337V33.1617C300.647 26.484 268.833 7.27333 201.414 33.1617C164.079 47.498 0 41.9398 0 41.9398V0Z"
        fill="#F3D0E6"
      />
    </svg>
  </div>
);

const PhotoAdvertisement = ({
  title = "Photo Advertisement",
  count = "09",
  message = "Promote your offers and videos on here",
  onOpen,
}) => {
  return (
    <button className="am-outer photo-advertisement-card" onClick={onOpen}>
      <CardBackground />

      <div className="photo-advertisement-card__header">
        <div className="photo-advertisement-card__header-left">
          <div className="photo-advertisement-card__icon-wrap">
            <PhotoIcon />
          </div>
          <p className="photo-advertisement-card__title">{title}</p>
        </div>
        <span className="photo-advertisement-card__badge">{count}</span>
      </div>

      <div className="photo-advertisement-card__body">
        <p className="photo-advertisement-card__body-text">{message}</p>
        <span className="photo-advertisement-card__view-all">
          View all <ArrowIcon />
        </span>
      </div>
    </button>
  );
};

const DesktopModalCloseButton = ({ onClose }) => (
  <div
    onClick={onClose}
    className="d-flex desktop-modal-close-button"
    role="button"
    aria-label="Close"
  >
    <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
    </svg>
  </div>
);

const TABS = [
  { key: "photo", label: "Photo Content", Icon: PhotoTabIcon },
  { key: "video", label: "Video Content", Icon: VideoTabIcon },
  { key: "text", label: "Text Content", Icon: TextTabIcon },
];

const CONTENT_TYPES = ["Aerobic", "Yoga", "Strength Training", "Cardio", "Meditation"];

const makeItems = (n, seedTitle) =>
  Array.from({ length: n }, (_, i) => ({
    id: `${seedTitle}-${i}`,
    title: "Title",
    date: "18/01/2026",
  }));

const TextLines = () => (
  <div className="am-text-placeholder">
    <div className="am-text-line am-text-line--1" />
    <div className="am-text-line am-text-line--2" />
    <div className="am-text-line am-text-line--3" />
  </div>
);

const ContentCard = ({ item, activeTab, onDelete }) => (
  <div className="am-card">
    <div className="am-thumb">
      <div style={{ position: "absolute", inset: 0 }}>
        {activeTab === "text" && <TextLines />}
      </div>
      <button
        className="am-card-delete-btn"
        onClick={() => onDelete(item.id)}
        aria-label="Delete"
      >
        <TrashIcon />
      </button>
    </div>
    <div className="am-card-body">
      <p className="am-card-title">{item.title}</p>
      <p className="am-card-date">Publish Date : {item.date}</p>
    </div>
  </div>
);

const ContentSection = ({ heading, items, activeTab, onDelete, showNav, showPublish, publishOn, onTogglePublish, onPrev, onNext }) => (
  <div>
    <div className="am-section-head-row">
      <div className="am-section-head-left">
        <h3 className="am-section-title">{heading}</h3>
        <span className="am-badge">1/10</span>
      </div>
      {showNav && (
        <div className="am-nav-btns">
          <button className="am-nav-btn" onClick={onPrev} aria-label="Previous">
            <ChevronLeftIcon />
          </button>
          <button className="am-nav-btn" onClick={onNext} aria-label="Next">
            <ChevronRightIcon />
          </button>
        </div>
      )}
      {showPublish && (
        <div className="am-publish-mode-row">
          <span className="am-publish-label">Publish Mode</span>
          <button
            className={`am-toggle${publishOn ? " am-toggle--on" : ""}`}
            onClick={onTogglePublish}
            aria-label="Toggle publish mode"
          >
            <span className={`am-toggle-knob${publishOn ? " am-toggle-knob--on" : ""}`} />
          </button>
        </div>
      )}
    </div>
    <div className="am-grid">
      {items.length === 0 ? (
        <div className="am-empty-slot">No content yet.</div>
      ) : (
        items.map((item) => (
          <ContentCard key={item.id} item={item} activeTab={activeTab} onDelete={onDelete} />
        ))
      )}
    </div>
  </div>
);

// ---- Upload Content form (shown when the plus button is tapped) ----
const UploadContentForm = ({ onSubmit }) => {
  const [contentType, setContentType] = useState("");
  const [isTypeDropdownOpen, setTypeDropdownOpen] = useState(false);
  const typeFieldRef = useRef(null);

  const [title, setTitle] = useState("");
  const [isTitleFocused, setTitleFocused] = useState(false);
  const titleInputRef = useRef(null);

  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);

  // Close the Content Type dropdown when clicking outside it
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (typeFieldRef.current && !typeFieldRef.current.contains(e.target)) {
        setTypeDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleFilePick = (e) => {
    const picked = e.target.files && e.target.files[0];
    if (!picked) return;
    setFile(picked);
    if (picked.type.startsWith("image/")) {
      setPreviewUrl(URL.createObjectURL(picked));
    } else {
      setPreviewUrl(null);
    }
  };

  const handleSubmit = () => {
    onSubmit && onSubmit({ contentType, title, file });
  };

  const typeActive = isTypeDropdownOpen || !!contentType;
  const titleActive = isTitleFocused || !!title;

  return (
    <div className="am-upload-wrap">
      {/* Content Type - floating label dropdown */}
      <div className="am-upload-field">
        <div
          ref={typeFieldRef}
          className={`float-field-type am-float-field${typeActive ? " am-float-field--active" : ""}`}
          onClick={() => setTypeDropdownOpen((v) => !v)}
        >
          <p className={`am-float-label${typeActive ? " am-float-label--active" : ""}`}>
            Content Type <span className="am-upload-required">*</span>
          </p>
          <p
            className={`am-float-input am-float-input--placeholder${contentType ? " am-float-input--has-value" : ""}`}
          >
            {typeActive ? (contentType || "Select Content Type") : ""}
          </p>
          <span className={`am-dropdown-arrow${isTypeDropdownOpen ? " am-dropdown-arrow--open" : ""}`}>
            <DownChevronIcon />
          </span>

          {isTypeDropdownOpen && (
            <div className="am-dropdown-panel">
              {CONTENT_TYPES.map((opt) => (
                <div
                  key={opt}
                  className={`upload-dropdown-item${opt === contentType ? " selected" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setContentType(opt);
                    setTypeDropdownOpen(false);
                  }}
                >
                  {opt}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div
        className="upload-dropzone am-dropzone"
        onClick={() => fileInputRef.current && fileInputRef.current.click()}
        role="button"
        aria-label="Upload image or video"
      >
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*,video/*"
          style={{ display: "none" }}
          onChange={handleFilePick}
        />
        {previewUrl ? (
          <img src={previewUrl} alt="Preview" className="am-preview-img" />
        ) : (
          <div className="am-dropzone-icon-wrap">
            <UploadImageIcon />
          </div>
        )}
        {!previewUrl && (
          <>
            <p className="am-dropzone-dims">1080 x 1080</p>
            <p className="am-dropzone-main">Upload Image / Video</p>
          </>
        )}
        {file && <p className="am-dropzone-note">{file.name}</p>}
        <p className="am-dropzone-note">Note - Please Upload Image/Video below 50 MB</p>
      </div>

      {/* Enter Title - floating label input */}
      <div className="am-upload-field">
        <div
          className={`float-field-title am-float-field${titleActive ? " am-float-field--active" : ""}`}
          onClick={() => titleInputRef.current && titleInputRef.current.focus()}
        >
          <p className={`am-float-label${titleActive ? " am-float-label--active" : ""}`}>
            Enter Title <span className="am-upload-required">*</span>
          </p>
          <input
            ref={titleInputRef}
            className="am-float-input"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onFocus={() => setTitleFocused(true)}
            onBlur={() => setTitleFocused(false)}
            placeholder={titleActive ? "Ex. Aerobic Session" : ""}
          />
        </div>
      </div>

      <button className="upload-submit-btn" onClick={handleSubmit}>
        Upload Content
      </button>
    </div>
  );
};

const AdvertisementManager = ({ onClose }) => {
  const [activeTab, setActiveTab] = useState("photo");
  const [publishOn, setPublishOn] = useState(false);
  const [liveItems, setLiveItems] = useState(makeItems(3, "live"));
  const [allItems, setAllItems] = useState(makeItems(3, "all"));
  const [view, setView] = useState("list"); // "list" | "upload"

  const removeLive = (id) => setLiveItems((prev) => prev.filter((i) => i.id !== id));
  const removeAll = (id) => setAllItems((prev) => prev.filter((i) => i.id !== id));

  const handleUploadSubmit = ({ contentType, title, file }) => {
    const newItem = {
      id: `all-${Date.now()}`,
      title: title || "Title",
      date: new Date().toLocaleDateString("en-GB").split("/").join("/"),
    };
    setAllItems((prev) => [newItem, ...prev]);
    setView("list");
  };

  return ReactDOM.createPortal(
    <div className="am-overlay" onClick={onClose}>
      <div
        className={`am-shell${view === "upload" ? " am-shell--upload" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="am-header">
          <div className="am-header-left">
            {view === "upload" ? (
              <button
                className="back-chevron-btn am-back-btn"
                onClick={() => setView("list")}
                aria-label="Back"
              >
                <BackChevronIcon />
              </button>
            ) : (
              <LogoMark />
            )}
            <div>
              <p className="am-header-title">
                {view === "upload" ? "Upload Content" : "Advertisement"}
              </p>
              <p className="am-header-subtitle">
                {view === "upload" ? "Add a new photo, video or text post" : "Manage yours add here"}
              </p>
            </div>
          </div>
          <div className="am-header-right">
            {view === "list" && (
              <button
                className="icon-btn-hover am-icon-btn"
                aria-label="Add"
                onClick={() => setView("upload")}
              >
                <PlusIcon />
              </button>
            )}
            {view === "list" && (
              <button className="icon-btn-hover am-icon-btn" aria-label="Publish to web">
                <GlobeIcon />
              </button>
            )}
            <DesktopModalCloseButton onClose={onClose} />
          </div>
        </div>

        <div className="am-scroll">
          {view === "upload" ? (
            <UploadContentForm onSubmit={handleUploadSubmit} />
          ) : (
            <>
              <div className="am-tabs-bar">
                {TABS.map((tab) => {
                  const { Icon } = tab;
                  const active = activeTab === tab.key;
                  return (
                    <button
                      key={tab.key}
                      className={`am-tab-btn${active ? " am-tab-btn--active" : ""}`}
                      onClick={() => setActiveTab(tab.key)}
                    >
                      <span className="am-tab-icon-wrap">
                        <Icon />
                      </span>
                      <span className="am-tab-label">{tab.label}</span>
                    </button>
                  );
                })}
              </div>

              <div className="am-body">
                <ContentSection
                  heading="Live Contents"
                  items={liveItems}
                  activeTab={activeTab}
                  onDelete={removeLive}
                  showNav
                />

                <hr className="am-divider" />

                <ContentSection
                  heading="All Contents"
                  items={allItems}
                  activeTab={activeTab}
                  onDelete={removeAll}
                  showPublish
                  publishOn={publishOn}
                  onTogglePublish={() => setPublishOn((v) => !v)}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

const AdvertisementCardWithModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <PhotoAdvertisement onOpen={() => setIsOpen(true)} />
      {isOpen && <AdvertisementManager onClose={() => setIsOpen(false)} />}
    </div>
  );
};

export default AdvertisementCardWithModal;